import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { BaseService} from 'src/app/service/base.service';

@Component({
  selector: 'app-ssologin',
  templateUrl: './ssologin.component.html',
  styleUrls: ['./ssologin.component.less']
})
export class SSOLoginComponent implements OnInit {

  constructor(private httpClient: HttpClient, private router: Router, private activatedRoute: ActivatedRoute, private baseService:BaseService) { }

  ngOnInit(): void {

    this.activatedRoute.queryParams.subscribe(params => {
      var token =decodeURI(atob(params['token']));
      var url = decodeURIComponent(params['formurl']);
      this.loginBySSOToken(token, url);
    });    
  }

  loginBySSOToken(token: any, url:any) {
    let body = {
      ssotoken : token
    };
  
    let options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json')
    };
  
    this.httpClient
      .post<any>(environment.wgProfileHost + "/oauth/ssotoken", body, options)
      .subscribe(response => {
        this.baseService.setToken(response.access_token);
         // Koristite navigateByUrl za preusmjeravanje na puni URL
        this.router.navigateByUrl(url);
      });
  }

}
